module.exports = __webpack_public_path__ + "img/Day2_final_lazy.8196f6e0.jpg";